<div class="formula-input-wrapper" [class.error]="validated() && !isValid()">
  <div
    #formulaEl
    class="formula-input"
    contenteditable="true"
    spellcheck="false"
    autocomplete="off"
    (input)="onInput($event)"
    (blur)="onBlur($event)"
    (keydown)="onKeydown($event)"
    (paste)="onPaste($event)"
  ></div>
  @if (isEmpty()) {
    <span class="formula-placeholder">e.g. round(temp1 + hum1 / 100)</span>
  }
</div>
<span class="label">Custom Formula*</span>
